module.exports = __webpack_public_path__ + "img/rpm-icon.4f7e7be0.svg";